import React from 'react';

// 차량 확인 아이콘 — 물품 아이콘(소·중·대박스·팔레트·가구)과 같은 아이소메트릭 일러스트 톤으로 그린 탑차(앞쪽 낮은 운전석 + 뒤쪽 높은 적재함).
// 색은 기존 아이콘에서 뽑은 값만 쓴다: 윗면 #f8d898 · 왼쪽면 #f0b858 · 오른쪽면 #c89050 · 음영 #b88850 · 바퀴 #383838 · 창 #f0f0f0, 반짝임은 브랜드 주황 #ff925c
function VehicleCheckIcon({ size = 48, className }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 80 80" aria-hidden="true">
      <ellipse cx="42" cy="61" rx="30" ry="5" fill="#f0e0b8" opacity="0.5" />
      {/* 적재함 */}
      <polygon points="30,24 56,12 74,21 48,33" fill="#f8d898" />
      <polygon points="30,24 48,33 48,53 30,44" fill="#f0b858" />
      <polygon points="48,33 74,21 74,41 48,53" fill="#c89050" />
      <polygon points="52,41 70,32 70,34.5 52,43.5" fill="#b88850" opacity="0.7" />
      {/* 운전석 */}
      <polygon points="10,38 28,29 36,33 18,42" fill="#f8d898" />
      <polygon points="10,38 18,42 18,54 10,50" fill="#f0b858" />
      <polygon points="18,42 36,33 36,45 18,54" fill="#e0a858" />
      <polygon points="20.5,42.5 33.5,36 33.5,41.5 20.5,48" fill="#f0f0f0" />
      <polygon points="28,29 36,33 36,45 30,48 30,44 30,24" fill="#c89050" opacity="0.35" />
      {/* 바퀴 */}
      <ellipse cx="15" cy="54" rx="4.6" ry="3.2" fill="#383838" />
      <ellipse cx="15" cy="53.4" rx="2" ry="1.4" fill="#f0f0f0" />
      <ellipse cx="40" cy="55" rx="4.6" ry="3.2" fill="#383838" />
      <ellipse cx="40" cy="54.4" rx="2" ry="1.4" fill="#f0f0f0" />
      <ellipse cx="64" cy="46" rx="4.6" ry="3.2" fill="#383838" />
      <ellipse cx="64" cy="45.4" rx="2" ry="1.4" fill="#f0f0f0" />
      {/* 반짝임 */}
      <path d="M66 4l1.9 4.6 4.6 1.9-4.6 1.9L66 17l-1.9-4.6-4.6-1.9 4.6-1.9z" fill="#ff925c" />
      <path d="M76 15l.9 2.2 2.2.9-2.2.9-.9 2.2-.9-2.2-2.2-.9 2.2-.9z" fill="#ff925c" opacity="0.8" />
    </svg>
  );
}

export default VehicleCheckIcon;
